module.exports = __webpack_public_path__ + "media/src/assets/Images/Circle-ec8c046d1764b246ccf1687f8f53499e.svg";